module.exports = __webpack_public_path__ + "img/beach_blonde.20e42de.png";